// NewCustomDropdown.jsx
import React from "react";
import { Dropdown, DropdownButton } from 'react-bootstrap';


const normalize = (item, getLabel, getValue) => {
  if (typeof item === 'string') return { label: item, value: item, _raw: item };
  return {
    label: getLabel ? getLabel(item) : item.label,
    value: getValue ? getValue(item) : item.value,
    _raw: item,
  };
};

export default function NewCustomDropdown({
  title = 'Select',
  icon,
  itemList = [],
  customStyles = '',
  selectedValue,                 // optional: value to show as current
  onSelect,                      // (item) => void  — receives the original item
  getLabel,                      // optional mappers if your object keys differ
  getValue,
}) {
  const items = itemList.map((it) => normalize(it, getLabel, getValue));
  const selected = selectedValue != null
    ? items.find((it) => String(it.value) === String(selectedValue))
    : null;

  const buttonTitle = (
    <>
      {icon ? (
        <div className="d-flex align-items-center gap-1 gap-sm-2">
          <span style={{ marginTop: '-2px' }} className="d-inline-block scale-8-mobile">
            {icon}
          </span>
          {selected ? selected.label : title}
        </div>
      ) : (
        selected ? selected.label : title
      )}
    </>
  );

  const handleSelect = (eventKey) => {
    const it = items.find((x) => String(x.value) === String(eventKey));
    if (onSelect && it) onSelect(it._raw); // return original object or string
  };

  return (
    <DropdownButton
      className={customStyles}
      id="dropdown-basic-button-data"
      title={buttonTitle}
      onSelect={handleSelect}
    >
      {items.map((it) => (
        <Dropdown.Item
          as="button"
          key={String(it.value)}
          eventKey={String(it.value)}
        >
          {it.label}
        </Dropdown.Item>
      ))}
    </DropdownButton>
  );
}
